import {
	VIEWPORT_STATE_ACTION_TYPES,
	ViewportSetWidthAction,
	ViewportState,
} from '../../../types/viewport'

const initialState: ViewportState = {
	width: window.innerWidth,
}

export default (
	state = initialState,
	action: ViewportSetWidthAction
): ViewportState => {
	switch (action.type) {
		case VIEWPORT_STATE_ACTION_TYPES.SET_VIEWPORT_WIDTH: {
			return {
				...state,
				width: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
